<template>
  <div>
    <div :id="id" :style="{ height: height - 32 + 'px' }" />
    <NoDataOverlay :model-value="!(value && Object.keys(value).length)" />
  </div>
</template>
  
  <script>
import * as echarts from "echarts";
import themeJson from "@/assets/echarts-themes/oceanic-balanced.json";
import { v4 as uuidv4 } from "uuid";
import NoDataOverlay from "@/components/atoms/analytics/NoDataOverlay.vue";

export default {
  name: "CampaignFunnel",
  components: {
    NoDataOverlay,
  },
  props: {
    id: {
      type: String,
      default: `campaign-funnel-${uuidv4()}`,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  data() {
    return {
      chartInstance: null,
      resizeObserver: null,
    };
  },
  watch: {
    value: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart();
    this.observeResize();
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
  },
  methods: {
    renderChart() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      const chart = echarts.init(chartDom, themeJson.themeName);
      chart.setOption(this.getOptions());

      this.chartInstance = chart;
    },
    observeResize() {
      const chartDom = document.getElementById(this.id);
      if (!chartDom) return;

      this.resizeObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          this.chartInstance?.resize();
        });
      });

      this.resizeObserver.observe(chartDom);
    },
    getOptions() {
      return {
        title: {
          text: "Funnel",
          left: "center",
        },
        tooltip: {
          trigger: "item",
          confine: true,
          formatter: "{a} <br/>{b} : {c}",
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        legend: {
          data: ["Impressions", "Views", "Clicks", "Visits", "Conversions"],
          bottom: 0,
          left: "center",
        },
        series: [
          {
            name: "Expected",
            type: "funnel",
            sort: "none",
            left: "20%",
            bottom: "10%",
            width: "60%",
            label: {
              formatter: "Exp: {c}",
            },
            labelLine: {
              show: false,
            },
            itemStyle: {
              opacity: 0.7,
            },
            emphasis: {
              label: {
                position: "inside",
                formatter: "Exp: {c}",
              },
            },
            data: [
              { value: this.value.impressions, name: "Impressions" },
              { value: this.value.views, name: "Views" },
              { value: this.value.clicks, name: "Clicks" },
              { value: this.value.visits, name: "Visits" },
              { value: this.value.conversions, name: "Conversions" },
            ],
          },
          // {
          //   name: "Actual",
          //   type: "funnel",
          //   sort: "none",
          //   left: "10%",
          //   bottom: "10%",
          //   width: "80%",
          //   maxSize: "80%",
          //   label: {
          //     position: "inside",
          //     formatter: "{c}",
          //     color: "#fff",
          //   },
          //   itemStyle: {
          //     opacity: 0.5,
          //     borderColor: "#fff",
          //     borderWidth: 2,
          //   },
          //   emphasis: {
          //     label: {
          //       position: "inside",
          //       formatter: "{b} Actual: {c}",
          //     },
          //   },
          //   data: [
          //     { value: this.value.impressions, name: "Impressions" },
          //     { value: this.value.views, name: "Views" },
          //     { value: this.value.clicks, name: "Clicks" },
          //     { value: this.value.visits, name: "Visits" },
          //     { value: this.value.conversions, name: "Conversions" },
          //   ],
          //   // Ensure outer shape will not be over inner shape when hover.
          //   z: 100,
          // },
        ],
      };
    },
  },
};
</script>
  
  <style scoped>
.inventory-item-pie-chart {
  width: 100%;
  font-family: Roboto, sans-serif;
}
</style>
  